/**
 * Executive Summary Tab (DC-1367)
 *
 * Renders executive briefing markdown from Anthropic.
 * Extracted from StrategicIntelligenceDashboard.tsx.
 */

import React from 'react';

interface ExecutiveSummaryTabProps {
  summary?: {
    summary: string;
    key_takeaway: string;
  };
}

export const ExecutiveSummaryTab: React.FC<ExecutiveSummaryTabProps> = ({ summary }) => {
  if (!summary) {
    return (
      <div className="summary-empty">
        <div className="empty-icon">📝</div>
        <h3>Executive Briefing</h3>
        <p>Generate AI insights to receive a strategic narrative synthesizing all station findings.</p>
      </div>
    );
  }

  return (
    <div className="executive-summary-content">
      <div className="summary-text">
        {summary.summary.split('\n\n').map((paragraph, idx) => (
          <p key={idx}>{paragraph}</p>
        ))}
      </div>
      <div className="key-takeaway">
        <strong>Key Takeaway:</strong> {summary.key_takeaway}
      </div>
    </div>
  );
};
